var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint0_radial_8099_89950)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint1_radial_8099_89950)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint2_radial_8099_89950)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.7492 13.6607C33.7492 14.9921 32.6698 16.0714 31.3384 16.0714C30.0071 16.0714 28.9277 14.9921 28.9277 13.6607C28.9277 12.3293 30.0071 11.25 31.3384 11.25C32.6698 11.25 33.7492 12.3293 33.7492 13.6607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5006 30.5357C26.9385 30.5357 30.5363 26.938 30.5363 22.5C30.5363 18.062 26.9385 14.4643 22.5006 14.4643C18.0626 14.4643 14.4648 18.062 14.4648 22.5C14.4648 26.938 18.0626 30.5357 22.5006 30.5357ZM22.5006 27.3214C25.1634 27.3214 27.322 25.1629 27.322 22.5C27.322 19.8371 25.1634 17.6786 22.5006 17.6786C19.8377 17.6786 17.6791 19.8371 17.6791 22.5C17.6791 25.1629 19.8377 27.3214 22.5006 27.3214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42773 21.8571C6.42773 16.4566 6.42773 13.7563 7.47874 11.6937C8.40323 9.87922 9.8784 8.40406 11.6928 7.47957C13.7555 6.42856 16.4558 6.42856 21.8563 6.42856H23.142C28.5425 6.42856 31.2428 6.42856 33.3054 7.47957C35.1199 8.40406 36.5951 9.87922 37.5195 11.6937C38.5706 13.7563 38.5706 16.4566 38.5706 21.8571V23.1428C38.5706 28.5433 38.5706 31.2436 37.5195 33.3063C36.5951 35.1207 35.1199 36.5959 33.3054 37.5203C31.2428 38.5714 28.5425 38.5714 23.142 38.5714H21.8563C16.4558 38.5714 13.7555 38.5714 11.6928 37.5203C9.8784 36.5959 8.40323 35.1207 7.47874 33.3063C6.42773 31.2436 6.42773 28.5433 6.42773 23.1428V21.8571ZM21.8563 9.64284H23.142C25.8954 9.64284 27.7669 9.64535 29.2136 9.76354C30.6229 9.87868 31.3436 10.0874 31.8463 10.3435C33.0558 10.9598 34.0392 11.9433 34.6556 13.1528C34.9118 13.6556 35.1205 14.3762 35.2356 15.7855C35.3537 17.2323 35.3563 19.1038 35.3563 21.8571V23.1428C35.3563 25.8962 35.3537 27.7677 35.2356 29.2145C35.1205 30.6238 34.9118 31.3444 34.6556 31.8471C34.0392 33.0567 33.0558 34.0401 31.8463 34.6564C31.3436 34.9126 30.6229 35.1214 29.2136 35.2364C27.7669 35.3546 25.8954 35.3571 23.142 35.3571H21.8563C19.1029 35.3571 17.2314 35.3546 15.7847 35.2364C14.3754 35.1214 13.6547 34.9126 13.152 34.6564C11.9425 34.0401 10.959 33.0567 10.3427 31.8471C10.0865 31.3444 9.87785 30.6238 9.76272 29.2145C9.64453 27.7677 9.64202 25.8962 9.64202 23.1428V21.8571C9.64202 19.1038 9.64453 17.2323 9.76272 15.7855C9.87785 14.3762 10.0865 13.6556 10.3427 13.1528C10.959 11.9433 11.9425 10.9598 13.152 10.3435C13.6547 10.0874 14.3754 9.87868 15.7847 9.76354C17.2314 9.64535 19.1029 9.64284 21.8563 9.64284Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8099_89950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0714 33.75) rotate(-55.3758) scale(41.0136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8099_89950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4643 46.6071) rotate(-65.1363) scale(36.3121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8099_89950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.41071 1.60714) rotate(-8.1301) scale(62.5032 13.3688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.39612d3244a88b48c69a550d0e5ee035.svg";
export { ForwardRef as ReactComponent };